import type * as React from 'react';

function SvgCircleCheckIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} fill="none" height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11" cy="11" fill="#00E889" r="11" />
      <path
        d="M15.538 6L17.1748 7.67813L9.18828 15.473L5 11.4736L6.61906 9.77859L9.17047 12.2152L15.538 6Z"
        fill="#022E4A"
      />
    </svg>
  );
}

export default SvgCircleCheckIcon;
